import { useTranslation } from "react-i18next";
import BorderRow from "../../../components/common/table/BorderRow";
import ServerSideTableColumnHeader from "../../../components/common/table/ServerSideTableColumnHeader";
import { TableHeaderStyles } from "./TransactionTable.styles";

export default function TransactionsTableHeader() {
  const { t } = useTranslation();

  return (
    <TableHeaderStyles>
      <ServerSideTableColumnHeader
        isSorted={false}
        label={t("wallet.transactions.sourceWalletName")}
        firstCol
      />
      <ServerSideTableColumnHeader
        isSorted={false}
        label={t("wallet.transactions.targetWalletName")}
      />
      <ServerSideTableColumnHeader
        isSorted={false}
        label={t("wallet.transactions.moduleDate")}
      />
      <ServerSideTableColumnHeader
        isSorted={false}
        label={t("wallet.transactions.bookingDate")}
      />
      <ServerSideTableColumnHeader
        isSorted={false}
        label={t("wallet.transactions.reason")}
      />
      <ServerSideTableColumnHeader
        isSorted={false}
        label={t("wallet.transactions.amount")}
      />
      <BorderRow />
    </TableHeaderStyles>
  );
}
